import UtilityService from "../UtilityService";

export default class UtilityProvinceList {

    static PROVINCE_LIST = null;
    static PROVINCE_LIST_LOADING = false;
    static PROVINCE_LIST_CALLBACKS = [];

    static retrieveProvinceList(callback = () => {
    }) {

        if (UtilityProvinceList.PROVINCE_LIST !== null) {
            callback(UtilityProvinceList.PROVINCE_LIST);
        } else {
            UtilityProvinceList.PROVINCE_LIST_CALLBACKS.push(callback);

            if (!this.PROVINCE_LIST_LOADING) {
                this.PROVINCE_LIST_LOADING = true;

                UtilityService.retrieveProvinceList().then(response => {
                    UtilityProvinceList.PROVINCE_LIST = response;
                    UtilityProvinceList.PROVINCE_LIST_LOADING = false;

                    this.PROVINCE_LIST_CALLBACKS.forEach(provinceListCallback => {
                        provinceListCallback(UtilityProvinceList.PROVINCE_LIST);
                    });
                    this.PROVINCE_LIST_CALLBACKS = [];

                });
            }
        }
    }
}
